module.exports = __webpack_public_path__ + "static/media/nursingweek.4b9ae33f.jpg";